import { render, staticRenderFns } from "./StatsShoots.vue?vue&type=template&id=ee064d5e&"
import script from "./StatsShoots.vue?vue&type=script&lang=js&"
export * from "./StatsShoots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports